export enum EIntegrationKeys {
  GTM = 'google-tag-manager',
  GoogleA4 = 'google-analytics-4',
  GoogleUA = 'google-universal-analytics',
  YandexMetrika = 'yandex-metrika',
  Noifications = 'notifications',
  GoogleCalendar = 'google',
  WazzUp = 'wazzup',
  AmoCRM = 'amocrm',
  CueBot = 'cue-bot',
  Widget = 'widget',
}

export interface IAmoCrmIntegrationValue {
  enabled?: boolean
  baseUrl?: string
  accessToken?: string
  accessTokenMasked?: string
  hasAccessToken?: boolean
  defaultPipelineId?: number
  defaultStatusId?: number
  defaultResponsibleUserId?: number | null
  closedStatusIds?: number[]
}

export interface IAmoCrmIntegrationProjection {
  id: number
  key: EIntegrationKeys.AmoCRM
  configured: boolean
  hasAccessToken: boolean
  accessTokenMasked: string
  value: IAmoCrmIntegrationValue
}

export interface IAmoCrmHealth {
  healthy: boolean
  reason?: string
}

export interface IIntegration<T = { code: string }, Key = EIntegrationKeys> {
  id?: number
  key: Key
  value: T
}
